<footer class="footer">
  <div class="footer-inner">

    <!-- Dati societari (art. 2250 c.c.): ogni voce compare solo se il valore in i18n è compilato -->
    <div class="footer-legal">
      <span class="footer-company">{{ 'FOOTER.LEGAL.COMPANY' | translate }}</span>
      <ng-container *ngFor="let item of legalItems">
        <span class="footer-legal-item" *ngIf="legalValue(item.valueKey) as value">
          <i class="fas" [ngClass]="item.icon" aria-hidden="true"></i>
          <span class="footer-legal-label">{{ item.labelKey | translate }}</span>
          <a *ngIf="isEmail(value); else plainValue" class="footer-legal-value" [href]="'mailto:' + value">{{ value }}</a>
          <ng-template #plainValue><span class="footer-legal-value">{{ value }}</span></ng-template>
        </span>
      </ng-container>
    </div>

    <!-- Copyright e link legali -->
    <div class="footer-bottom">
      <p class="footer-copyright">{{ 'FOOTER.COPYRIGHT' | translate: { year: currentYear } }}</p>
      <nav class="footer-links" aria-label="Link legali">
        <!-- Informative ufficiali dell'azienda (URL in i18n, FOOTER.LINKS.*) -->
        <ng-container *ngFor="let link of legalLinks">
          <a class="footer-link" *ngIf="legalValue(link.urlKey) as url" [href]="url" target="_blank" rel="noopener noreferrer">
            <i class="fas" [ngClass]="link.icon" aria-hidden="true"></i>
            {{ link.labelKey | translate }}
          </a>
        </ng-container>
        <!-- Termini di servizio e Privacy del portale (/tos pubblico, /private/tos da loggati): voce nascosta, rotte attive
        <a class="footer-link" [routerLink]="tosLink">
          <i class="fas fa-file-contract" aria-hidden="true"></i>
          {{ 'FOOTER.TOS' | translate }}
        </a>
        -->
      </nav>
    </div>

  </div>
</footer>
